export const enum ModalKey {
  DEV_MODAL = 'DEV_MODAL',
  EDIT_HANDOVER_DELIVERY = 'EDIT_HANDOVER_DELIVERY',
  MULTISTEP_EDIT_HANDOVER = 'MULTISTEP_EDIT_HANDOVER',
  ERROR_MODAL = 'ERROR_MODAL',
  SUCCESS_MODAL = 'SUCCESS_MODAL',
  INFO_MODAL = 'INFO_MODAL',
  REDEMPTION_MODAL = 'REDEMPTION_MODAL',
}
export const MODAL_UNMOUNT_DELAY_MS = 250;
